import e from "./_arrayPush.js";
import u from "./isArray.js";
function l(r, s, t) {
  var a = s(r);
  return u(r) ? a : e(a, t(r));
}
export {
  l as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_baseGetAllKeys.js
// module id = 906
// module chunks = 67